export const OC_B_ORDER = {
  SG_C_PERCENT_STRATEGY_SKU: { // 百分比分货策略-参与商品明细
    table: 'SG_C_PERCENT_STRATEGY_SKU',
    objid: -1,
    refcolid: 1700862445, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'SG_C_PERCENT_STRATEGY_SKU.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_LOG_DETAIL: { // 寻源占单详情
    table: 'OC_B_ORDER_LOG_DETAIL',
    objid: -1,
    refcolid: 1700859745, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_LOG_DETAIL.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_RETURN_ORDER_SN: { // 退换货-SN信息
    table: 'OC_B_RETURN_ORDER_SN',
    objid: -1,
    refcolid: 1700857000, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_RETURN_ORDER_SN.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_SN: { // 零售-SN信息
    table: 'OC_B_ORDER_SN',
    objid: -1,
    refcolid: 1700856342, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_SN.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_VIPCOM_RETURN_PO_ITEM: { // 唯品会退货单-条码明细
    table: 'OC_B_VIPCOM_RETURN_PO_ITEM',
    objid: 1, // 主表传入的明细ID
    refcolid: 1700826243, // 子表的主键ID
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      startindex: 0,
      fixedcolumns: { SKU_FILTER_TYPE: 'ALL' },
    }
  },
  SG_B_STO_WAREHOUSE_PROCESS_RESULT: { // 仓库操作状态
    table: 'SG_B_STO_WAREHOUSE_PROCESS_RESULT',
    objid: 1, // 主表传入的明细ID
    refcolid: 1700841440, // 子表的主键ID
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'SG_B_STO_WAREHOUSE_PROCESS_RESULT.SOURCE_BILL_ID', asc: true }],
      startindex: 0
    }
  },
  OC_B_ORDER_PROMOTION: { // 优惠信息
    table: 'OC_B_ORDER_PROMOTION',
    objid: 97,
    refcolid: 168873,
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_PROMOTION.ID', asc: true }],
      startindex: 0
    }
  },
  OC_B_RETURN_ORDER_ACTUAL: { // 实物商品
    table: 'OC_B_RETURN_ORDER_ACTUAL',
    objid: '-1',
    refcolid: 1700843040,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_RETURN_ORDER_ACTUAL.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  OC_B_REFUND_IN_ACTUAL: { // 实际入库商品
    table: 'OC_B_REFUND_IN_ACTUAL',
    objid: '-1',
    refcolid: 1700843145,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_REFUND_IN_ACTUAL.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  OC_B_RETURN_ORDER: { // 退货日志
    table: 'OC_B_RETURN_ORDER_LOG',
    objid: 2, // 表id
    refcolid: 171736,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_RETURN_ORDER_LOG.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  ORDER_LOGISTICS_TRAJECTORY_RETURN: { // 物流轨迹
    table: 'ORDER_LOGISTICS_TRAJECTORY_RETURN',
    objid: 850869, // 表id
    refcolid: 1700836170,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'ORDER_LOGISTICS_TRAJECTORY_RETURN.KPI_TIME', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  OC_B_RETURN_ORDER_NODE_RECORD: { // 退单状态
    table: 'OC_B_RETURN_ORDER_NODE_RECORD',
    objid: 5976871, // 表id
    refcolid: 1700836722,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_RETURN_ORDER_NODE_RECORD.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  OC_B_REFUND_IN: { // 退货入库日志
    table: 'OC_B_REFUND_IN_LOG',
    objid: 11192, // 表id
    refcolid: 176192,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_REFUND_IN_LOG.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  OC_B_REFUND_IN_BATCH_ITEM: { // 退货入库 - 批次明细
    table: 'OC_B_REFUND_IN_BATCH_ITEM',
    objid: 11192,
    refcolid: 1700852370,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_REFUND_IN_BATCH_ITEM.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  OC_B_ORDER_GIFT_CARD: { // 礼品卡信息
    table: 'OC_B_ORDER_GIFT_CARD',
    objid: 97,
    refcolid: 1700856683,
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_GIFT_CARD.ID', asc: true }],
      startindex: 0
    }
  },
  OC_B_ORDER_PAYMENT: { // 支付信息
    table: 'OC_B_ORDER_PAYMENT',
    objid: 97,
    refcolid: 168874,
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_PAYMENT.ID', asc: true }],
      startindex: 0
    }
  },
  OC_B_ORDER_DELIVERY: { // 发货信息
    table: 'OC_B_ORDER_DELIVERY',
    objid: 97,
    refcolid: 168912,
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_DELIVERY.ID', asc: true }],
      startindex: 0
    }
  },
  OC_B_ORDER_LOGISTICS_PACKAGE_ITEM: {
    table: 'OC_B_ORDER_LOGISTICS_PACKAGE_ITEM',
    objid: 5976550,
    refcolid: 1700860249, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_LOGISTICS_PACKAGE_ITEM.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_LOGISTICS_TRAJECTORY: { // 物流轨迹
    table: 'OC_B_ORDER_LOGISTICS_TRAJECTORY',
    objid: 5976550,
    refcolid: 1700836142, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_LOGISTICS_TRAJECTORY.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_NAIKA_DETAIL: {
    table: 'OC_B_ORDER_NAIKA_DETAIL',
    objid: -1,
    refcolid: 1700841656, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_NAIKA_DETAIL.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_EQUAL_EXCHANGE_ITEM: {
    table: 'OC_B_ORDER_EQUAL_EXCHANGE_ITEM',
    objid: -1,
    refcolid: 1700841624, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_EQUAL_EXCHANGE_ITEM.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_MATERIALS_SUGGEST_RESULT: {
    table: 'OC_B_MATERIALS_SUGGEST_RESULT',
    objid: -1,
    refcolid: 1700859663,
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_MATERIALS_SUGGEST_RESULT.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_NODE_RECORD: { // 订单状态
    table: 'OC_B_ORDER_NODE_RECORD',
    objid: 5976871,
    refcolid: 1700836694, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_NODE_RECORD.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_LOG: { // 发货信息日志
    table: 'OC_B_ORDER_LOG',
    objid: 97,
    refcolid: 172890, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_LOG.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_WMS_STATUS: { // 仓内状态
    table: 'OC_B_ORDER_WMS_STATUS',
    objid: 97,
    refcolid: 374206, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_WMS_STATUS.ID', asc: false }],
      startindex: 0
    }
  },
  OC_B_ORDER_ROUTE: { // 路由信息
    table: 'OC_B_ORDER_ROUTE',
    objid: 97,
    refcolid: 1700811304, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      // "orderby": [{ "column": "OC_B_ORDER_ROUTE.ID", "asc": false }],
      startindex: 0
    }
  },
  OC_B_ORDER_ITEM: { // 訂單明細
    table: 'OC_B_ORDER_ITEM',
    objid: 97,
    refcolid: 169188, // 关联表id
    searchdata: {
      column_include_uicontroller: true,
      range: 10,
      orderby: [{ column: 'OC_B_ORDER_ITEM.ID', asc: true }],
      startindex: 0
    }
  },
  OC_B_JD_REFUND_IN: { // 京东退货入库日志
    table: 'OC_B_JD_REFUND_IN_LOG',
    objid: 11192, // 表id
    refcolid: 1700810384,
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_JD_REFUND_IN_LOG.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  OC_B_ORDER_MAKE_UP_DIFF_PRICE: { // 差价单信息
    table: 'OC_B_ORDER_MAKE_UP_DIFF_PRICE',
    objid: 11192, // 表id
    refcolid: 1700848656, // 关联表字段id
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'OC_B_ORDER_MAKE_UP_DIFF_PRICE.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
  PS_C_PRO_GROUP_LOG: { // 组合商品操作日志
    table: 'PS_C_PRO_GROUP_LOG',
    objid: 11192, // 表id
    refcolid: 249231915, // 关联表字段id
    searchdata: {
      column_include_uicontroller: true,
      orderby: [{ column: 'PS_C_PRO_GROUP_LOG.ID', asc: false }],
      range: 10,
      fixedcolumns: {},
      startindex: 0
    }
  },
};

export const BILL_STATUS = {
  UNCONFIRMED: 1, // 未确认
  OUT_OF_STOCK: 2, // 缺货
  AUDITED: 3, // 已审核
  DISTRIBUTION: 4, // 配货中
  WAREHOUSE_DELIVERY: '', // 仓库发货
  PLATFORM_DELIVERY: 6, // 平台发货
  CANCELLED: '', // 已取消
  SYSTEM_INVALIDATION: '', // 系统作废
  ADVANCE_SALE: 9, // 预售
  SUBSTIIUTION: 10, // 代发
  LOGISTICS_DELIVERY: 11, // 物流已送达
  TRANSACTION_COMPLETED: 12, // 交易完成
  UNPAID: 13, // 未付款
  PAENDING_WMS: 21, // 待传WMS
  PAENDING_ALLOCATED: 50, // 待分配
  PRE_SALE_DELIVERY: 51, // 预售待发货
  ADVANCE_SHORTAGE: 52, // 预售缺货
};

export default {
  OC_B_ORDER,
  BILL_STATUS
};
